import { render, staticRenderFns } from "./OptionCollapse.vue?vue&type=template&id=40a3d7ca"
import script from "./OptionCollapse.vue?vue&type=script&lang=ts"
export * from "./OptionCollapse.vue?vue&type=script&lang=ts"
import style0 from "./OptionCollapse.vue?vue&type=style&index=0&id=40a3d7ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports